import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { usePlacesWidget } from "react-google-autocomplete";
import { Controller } from "react-hook-form";
import { baseUrl, googleApiKey } from "../../constants/common";

/**
 * Component for Google Auto Complete Input
 * @param {object} props
 * @param {function} props.onChange - Handle the change event of Input
 * @component
 */


let requestTimeoutId;
let optionsHideTimeoutId;
const PlaceAutoComplete = ({
  name,
  value,
  onChange,
  onKeyPress = null,
  error,
  label,
  helperText,
  control,
  placeholder = "",
  disable = false,
  defaultValue = "",
  ...rest
}) => {
  const [placesSearched, setPlacesSearched] = useState([])
  const [isFocused, setIsFocused] = useState(false)

  function compIsType(t, s) {
    for (let z = 0; z < t.length; ++z) if (t[z] === s) return true;
    return false;
  }

  async function handlePlaceSelect(placeId) {
    clearTimeout(optionsHideTimeoutId)
    const url = `${baseUrl}/api/places/details/${placeId}`
    try {
      const response = await fetch(url);
      const data = await response.json();

      let city = "";
      let state = "";
      let zipCode = "";

      if (data.addressComponents !== undefined) {
        let addrComp = data.addressComponents;
        for (let i = 0; i < addrComp.length ?? 0; ++i) {
          let typ = addrComp[i].types;
          if (compIsType(typ, "administrative_area_level_1")) {
            state = addrComp[i].longText;
          }
          if (compIsType(typ, "locality")) {
            city = addrComp[i].longText;
          }
          if (compIsType(typ, "postal_code")) {
            zipCode = addrComp[i].longText;
          }
        }
      }

      const selectedAddress = {
        location: data?.formattedAddress || "",
        lat: data?.location?.latitude,
        lng: data?.location?.longitude,
        city,
        zipCode,
        state,
      };

      onChange(selectedAddress);
      setIsFocused(false)
      console.log(selectedAddress)
    } catch (error) {
      console.error(error)
    }
  }

  async function handlePlaceSearch(placeSearch) {
    clearTimeout(requestTimeoutId);
    setPlacesSearched([])
    if (!placeSearch.trim()) return
    requestTimeoutId = setTimeout(async () => {
      const url = `${baseUrl}/api/places/autocomplete`;
      const options = {
        method: 'POST',
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          input: placeSearch,
          // sessionToken: '//todo'
        })
      };

      try {
        const response = await fetch(url, options);
        const data = await response.json();
        const suggestions = data.suggestions.map(sug => ({
          placeId: sug.placePrediction.placeId,
          mainText: sug.placePrediction.structuredFormat.mainText.text,
          secondaryText: sug.placePrediction.structuredFormat.secondaryText.text
        }))
        setPlacesSearched(suggestions)
      } catch (error) {
        console.error(error);
      }
    }, 600);
  }

  const renderTextField = (fieldProps) => (
    <div style={{ position: 'relative' }}>
      <TextField
        {...fieldProps}
        label={label}
        name={name}
        error={error}
        helperText={helperText}
        placeholder={placeholder}
        disabled={disable}
        onKeyUp={onKeyPress}
        {...rest}
        onFocus={() => {
          console.log('focusssed!')
          setIsFocused(true)
        }}
        onBlur={() => {
          console.log('blurred!')
          optionsHideTimeoutId = setTimeout(() => {
            setIsFocused(false)
          }, 500);
        }}
        onChange={(e) => {
          const targetSearchText = e.target.value
          console.log('changeee', targetSearchText)
          handlePlaceSearch(targetSearchText)
          fieldProps?.onChange(e)
        }}
      />

      <div class="pac-container pac-logo hdpi"
        style={{ position: 'absolute', left: 0, right: 0, display: isFocused ? 'block' : 'none' }}
      >
        {placesSearched.map((place) => (
          <div class="pac-item" key={place.placeId} onClick={() => handlePlaceSelect(place.placeId)}>
            <span class="pac-icon pac-icon-marker"></span>
            <span class="pac-item-query">
              <span class="pac-matched">{place.mainText}</span>
            </span>
            <span>{place.secondaryText}</span>
          </div>
        ))}
      </div>

    </div>
  );

  return control ? (
    <Controller
      name={name}
      control={control}
      render={({ field }) => renderTextField(field)}
    />
  ) : (
    renderTextField()
  );
};

export default PlaceAutoComplete;
